import React from 'react';
import EmployeeDischargeList from './components/EmployeeDischargeList';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <EmployeeDischargeList />
    </div>
  );
};

export default App;
